export default __webpack_public_path__ + "static/media/green.9d571c8f.svg";